module.exports = __webpack_public_path__ + "static/media/2.ce3c43fb.jpg";